import { render } from "./UploadAlertModal.vue?vue&type=template&id=3918c04a"
import script from "./UploadAlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadAlertModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/UploadAlertModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3918c04a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3918c04a', __exports__)) {
    api.reload('3918c04a', __exports__)
  }
  
  module.hot.accept("./UploadAlertModal.vue?vue&type=template&id=3918c04a", () => {
    api.rerender('3918c04a', render)
  })

}


export default __exports__